import type { FC } from "react";
import { TextBody } from "@/ui/components/typography/TextBody";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import {
  FOOTER_PRIMARY_NAVIGATION_LIST_CLASS_NAME,
  type TFooterNavigationSection,
} from "./Footer.config";

type TFooterPrimaryNavigationListProps = {
  sections: TFooterNavigationSection[];
};

export const FooterPrimaryNavigationList: FC<TFooterPrimaryNavigationListProps> = ({
  sections,
}) => (
  <nav
    aria-label="Primary footer navigation"
    data-component="FooterPrimaryNavigationList"
    className="w-full md:w-fit"
  >
    <ul className={FOOTER_PRIMARY_NAVIGATION_LIST_CLASS_NAME}>
      { sections.map((section) => (
        <li key={section.id} className="min-w-0">
          <TextSubtitle
            tag="h2"
            isResponsive={false}
            className="px-2 py-4 !text-sys-white md:mb-6 md:p-0 xl:text-sys-2xl"
          >
            { section.title }
          </TextSubtitle>
          <ul className="flex flex-col gap-1 md:gap-4">
            { section.links.map((link) => (
              <li key={link.id}>
                <TextBody
                  tag="span"
                  color="inherit"
                  size={2}
                  isResponsive={false}
                  className="text-sys-grey-50 xl:text-sys-lg"
                >
                  <a
                    href={link.href}
                    className="block px-4 py-1 md:p-0"
                  >
                    { link.label }
                  </a>
                </TextBody>
              </li>
            )) }
          </ul>
        </li>
      )) }
    </ul>
  </nav>
);

FooterPrimaryNavigationList.displayName = "FooterPrimaryNavigationList";
